namespace Matrix.Data {
    export interface AccountModelTargetBatchUpdateRequest extends Serenity.ServiceRequest {
        ModelCode?: string;
        AccountCode?: string;
        Targets?: AccountModelTargetRow[];
    }
}
